import { loadFontFaces } from '@genesislcap/foundation-utils';

export const mixinRobotoMedium = (style = 'normal', weight = 'normal') => `
  font-family: "Roboto-Medium", "Roboto Medium", "Roboto", sans-serif; 
  font-style: ${style};
  font-weight: ${weight};
`;

export const mixinRobotoRegular = `
  font-family: "Roboto-Regular", "Roboto Regular", "Roboto", sans-serif; 
`;

export const mixinRobotoBold = `
  font-family: "Roboto-Bold", "Roboto Bold", "Roboto", sans-serif; 
`;

export const stylesFontFaces = `
  @font-face {
    font-family: Segoe UI;
    font-weight: 300;
    src: local("Segoe UI Semilight"), local("Segoe UI");
  }

  * {
    ${mixinRobotoMedium()}
  }
`;

export const mixinCardTitle = mixinRobotoMedium('normal', 'bold');

export const stylesHeaders = `
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
  }
`;

export const robotoFontFaces = `
  @font-face {
    font-family: 'Roboto';
    src: url('../assets/fonts/roboto/Roboto-Regular.woff2') format('woff2');
  }

`;

loadFontFaces(robotoFontFaces, 'roboto-font-faces');
